import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css'; 

const Navbar = () => {
  const [time, setTime] = useState(() => new Date());

  useEffect(() => {
    const interval = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

return (
  <>
    <nav className="navbar">
      <NavLink
        to="/"
        className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
      >
        Sākums
      </NavLink>
      <NavLink
        to="/about"
        className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
      >
        Par mani
      </NavLink>
      <NavLink
        to="/gallery"
        className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
      >
        Galerija
      </NavLink>       
      <NavLink
        to="/contact"
        className={({ isActive }) => isActive ? "nav-link active" : "nav-link"}
      >
       Raksti man
      </NavLink>
      <div style= {{ 
        display: 'flex', 
        alignItems: 'right', 
        marginLeft: 'auto', 
        fontSize: '1.1em', 
        fontFamily: 'IBM Plex Serif, monospace',
        color: '#191516ff', 
      }}>
   
    <div style={{ 
  display: 'flex', 
  alignItems: 'center', 
  marginLeft: 'auto', 
  fontSize: '0.6em', 
  fontFamily: 'Unbounded, monospace',
  color: '#191516ff',
  gap: '1em'
}}>
  <span role="img" aria-label="Latvian flag" style={{ fontSize: '1.2em' }}>🇱🇻</span>
  <span>Rīga, Latvija </span>
  <span>{time.toLocaleTimeString()}</span>
</div>
      </div>
    </nav>
  </>
);
};

export default Navbar;

